








































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {AppUserHistoryEditModel, WorkHoursDay} from '@/services/api/nswag/stapiclient_generated';
import {stAppUserHistoryApi} from '@/services/st-api';
import { ObjectEditor } from "@/utlitities/helper";
import { remove } from "lodash";

@Component({
  components: {},
})
export default class AppUserHistory extends Vue {
  @Prop() appUserId!: number;
  @Prop() value!: AppUserHistoryEditModel[];

  historyItems: ObjectEditor<AppUserHistoryEditModel>[] = [];
  displayWarning = false;

  async mounted() {
    let unwatch = this.$watch('value', ()=>{
      this.value.forEach(x=>{
        this.historyItems.push(new ObjectEditor<AppUserHistoryEditModel>(x));
        unwatch();
      });
    });
  }

  saveItem(item: ObjectEditor<AppUserHistoryEditModel>){
    item.editMode = false;
    this.displayWarning = false;
    this.updateOutside();
  }

  cancel(item: ObjectEditor<AppUserHistoryEditModel>, index: number){
    this.displayWarning = false;
    if(item.isNew){
      this.remove(index);
    }else{
      item.reset();
    }
  }

  async updateOutside(){
    this.$emit('input', this.historyItems.map(x=>x.val));
    await this.$nextTick();
    this.historyItems = [];
    this.value.forEach(x=>{
      this.historyItems.push(new ObjectEditor<AppUserHistoryEditModel>(x));
    });
  }

  get isEditingItem() {
    return this.historyItems.filter((_) => _.editMode).length > 0;
  }

  remove(index: number) {
    this.historyItems.splice(index, 1);
    this.updateOutside();
  }

  async addNewItem() {
    let newItem = await stAppUserHistoryApi.getNew(this.appUserId);
    let newHistoryItem = new ObjectEditor<AppUserHistoryEditModel>(newItem);
    newHistoryItem.editMode = true;
    newHistoryItem.isNew = true;
    this.historyItems.unshift(newHistoryItem);
  }

  weeklyWorkHoursChanged(item: AppUserHistoryEditModel) {
    if (item.weeklyWorkHours || item.weeklyWorkHours == 0) {
      const dailyWorkHours = item.weeklyWorkHours / 5;

      item.dailyWorkHours?.forEach((val: WorkHoursDay, index: number) => {
        if (index < 5) {
          val.workingHours = dailyWorkHours;
        } else {
          val.workingHours = 0;
        }
      });
    }
  }

  dailyWorkHoursChanged(item: AppUserHistoryEditModel) {
    if (item.dailyWorkHours) {
      item.weeklyWorkHours = item
          .dailyWorkHours!.map((x) => {
        if (!x.workingHours) {
          return 0;
        }
        return x.workingHours!;
      })
          .reduce((x, y) => {
            return parseFloat(x.toString()) + parseFloat(y.toString());
          });
    }
  }
}
